import { ActionBase } from '../../../core/store/action/ActionBase';

export const CREATEDRAFT_DYNAMICDATASET = '[DynamicDataSet] Create Draft';

export class CreateDraftDynamicDataSetAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = CREATEDRAFT_DYNAMICDATASET;

  constructor(public payload: { dynamicDataSetKey: string }) {}
}



// WEBPACK FOOTER //
// ./src/app/dynamicDataSets/store/actions/CreateDraftDynamicAction.ts